import { Typography } from "@material-tailwind/react";
import React from "react";

function DetailListItem({ title, items, containerStyle }) {
  return (
    <div className={`flex flex-col flex-1 mb-5 ${containerStyle}`}>
      <Typography
        color="black"
        variant="paragraph"
        className="text-left w-full"
      >
        <span className="uppercase font-bold text-sm detail-title">
          {title}
        </span>
      </Typography>
      <ul className="list-disc pl-5 space-y-2">
        {items.map((item, index) => (
          <li key={index}>
            <Typography
              color="black"
              variant="paragraph"
              className="text-left text-xl w-full"
            >
              <span>{item}</span>
            </Typography>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DetailListItem;
